var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdinateurs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ordinateur"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.84,41.33H52.16V20.27a2.37,2.37,0,0,0-2.37-2.37H16.19a2.37,2.37,0,0,0-2.37,2.37V41.33H11.14a.61.61,0,0,0-.61.61v2.72A3.42,3.42,0,0,0,14,48.08H52a3.42,3.42,0,0,0,3.42-3.42V41.94A.61.61,0,0,0,54.84,41.33ZM15.05,20.27a1.14,1.14,0,0,1,1.14-1.14h33.6a1.15,1.15,0,0,1,1.15,1.14V41.33H15.05ZM25.79,42.55h14.4V43A1.15,1.15,0,0,1,39,44.09H26.93A1.15,1.15,0,0,1,25.79,43Zm28.44,2.11A2.2,2.2,0,0,1,52,46.85H14a2.2,2.2,0,0,1-2.2-2.19V42.55H24.57V43a2.37,2.37,0,0,0,2.36,2.37H39A2.37,2.37,0,0,0,41.41,43v-.4H54.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.65,38.43V22a.61.61,0,0,0-.61-.61H17.94a.61.61,0,0,0-.61.61V38.43a.61.61,0,0,0,.61.61H48A.61.61,0,0,0,48.65,38.43Zm-1.22-.61H18.56V22.64H47.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.42,33.8a.62.62,0,0,0,.87,0h0l6.27-6.28a.62.62,0,0,0-.87-.87l-6.27,6.28a.62.62,0,0,0,0,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.32,32.41a.62.62,0,0,0,.87,0l3.5-3.5a.62.62,0,0,0-.87-.87l-3.5,3.5a.62.62,0,0,0,0,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.73,32.59a.62.62,0,0,0,.43-.18l3.5-3.5a.62.62,0,0,0,0-.87.62.62,0,0,0-.87,0h0l-3.49,3.5a.62.62,0,0,0,0,.87.62.62,0,0,0,.43.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdinateurs);
export default __webpack_public_path__ + "static/media/ordinateurs.1deaac3b382232097a31067fe3f53b6f.svg";
export { ForwardRef as ReactComponent };